import React from "react";
import PropTypes from "prop-types";
import TabNav from "../common/TabNav";
import TabNavItem from "../common/TabNavItem";
import { GetTopNavItems } from "./NavItemHelper";

const TopNav = ({ topNavTabSettings, scope, transactionId, isReadOnly }) => {
	const items = GetTopNavItems(topNavTabSettings, scope, transactionId);
	return (
		<nav>
			<TabNav>
				{items.map((item, i) =>
					<TabNavItem
						key={i}
						display={item.text}
						iconType={item.iconType}
						color={item.color}
						to={item.to}
						disabled={item.disabled}
						visible={item.tabNr === 99 ? item.visible && !isReadOnly : item.visible}
						hideText={item.hideText}
						showBead={item.showBead}
						customNavAction={item.customNavAction} />
				)}
			</TabNav>
		</nav>
	);
};

TopNav.propTypes = {
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	transactionId: PropTypes.string,
	isReadOnly: PropTypes.bool
};

export default TopNav;